import styled, { keyframes } from "styled-components";
import { colors } from "../../../../styles/colors";

const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: calc(200px + 100%) 0;
  }
`;

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const SkeletonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 18px;
  row-gap: 16px;
`;

export const SkeletonCard = styled.div<{ $delay: number }>`
  background: ${colors.white};
  border-radius: 9px;
  border: 0.5px solid ${colors.lightBlueGray};
  padding: 10px 20px 12px 12px;
  position: relative;
  animation: ${fadeInUp} 0.6s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay}s;
  opacity: 0;
`;

export const SkeletonCardHeader = styled.div`
  height: 20px;
  background: linear-gradient(
    90deg,
    ${colors.lightGray} 25%,
    ${colors.blueGray}20 50%,
    ${colors.lightGray} 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 4px;
  margin-bottom: 12px;
  width: 60%;
`;

export const SkeletonCardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SkeletonBodyItem = styled.div<{ $delay: number }>`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  animation: ${fadeInUp} 0.4s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay}s;
  opacity: 0;

  .skeleton-text {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .skeleton-title {
      width: 80px;
      height: 12px;
      background: linear-gradient(
        90deg,
        ${colors.lightGray} 25%,
        ${colors.blueGray}20 50%,
        ${colors.lightGray} 75%
      );
      background-size: 200px 100%;
      animation: ${shimmer} 1.5s infinite;
      border-radius: 2px;
    }

    .skeleton-value {
      width: 60px;
      height: 20px;
      background: linear-gradient(
        90deg,
        ${colors.lightGray} 25%,
        ${colors.blueGray}20 50%,
        ${colors.lightGray} 75%
      );
      background-size: 200px 100%;
      animation: ${shimmer} 1.5s infinite;
      border-radius: 3px;
    }
  }

  .skeleton-icon {
    width: 18px;
    height: 18px;
    background: linear-gradient(
      90deg,
      ${colors.lightGray} 25%,
      ${colors.blueGray}20 50%,
      ${colors.lightGray} 75%
    );
    background-size: 200px 100%;
    animation: ${shimmer} 1.5s infinite;
    border-radius: 2px;
    margin-bottom: 5px;
  }
`;

export const SkeletonChart = styled.div`
  height: 80px;
  background: linear-gradient(
    90deg,
    ${colors.lightGray} 25%,
    ${colors.blueGray}20 50%,
    ${colors.lightGray} 75%
  );
  background-size: 200px 100%;
  animation: ${shimmer} 1.5s infinite;
  border-radius: 6px;
  margin-top: 8px;
  position: relative;
  overflow: hidden;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(
      90deg,
      transparent 0%,
      rgba(255, 255, 255, 0.4) 50%,
      transparent 100%
    );
    animation: ${shimmer} 1.5s infinite;
  }
`;
